import Card from '../../components/Card';
import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { useT } from '../../utils/useTranslation';
import api, { DB_TYPE } from '../../api';
import { db } from '../../firebase';
import { getDocs, collection, doc, updateDoc, addDoc, query, orderBy } from 'firebase/firestore';
import { motion, AnimatePresence } from 'framer-motion';
export default function ManageVotes() {
  const t = useT();
  const [votes, setVotes] = useState([]);
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({
    title: '',
    description: '',
    startDate: '',
    endDate: '',
    candidates: [{
      name: ''
    }, {
      name: ''
    }]
  });
  const load = async () => {
    if (DB_TYPE === 'firebase') {
      try {
        const snap = await getDocs(query(collection(db, 'votes'), orderBy('createdAt', 'desc')));
        setVotes(snap.docs.map(d => ({ _id: d.id, ...d.data() })));
      } catch (err) { console.error(err); }
      finally { setLoading(false); }
    } else {
      api.get('/votes').then(r => {
        setVotes(r.data);
        setLoading(false);
      }).catch(() => setLoading(false));
    }
  };
  useEffect(() => {
    load();
  }, []);
  const addCandidate = () => setForm(p => ({
    ...p,
    candidates: [...p.candidates, {
      name: ''
    }]
  }));
  const setCandidate = (i, v) => setForm(p => ({
    ...p,
    candidates: p.candidates.map((c, j) => j === i ? {
      ...c,
      name: v
    } : c)
  }));
  const removeCandidate = i => setForm(p => ({
    ...p,
    candidates: p.candidates.filter((_, j) => j !== i)
  }));
  const save = async e => {
    e.preventDefault();
    try {
      const candidates = form.candidates
        .filter(c => c.name.trim())
        .map(c => ({ ...c, votes: 0 }));

      if (DB_TYPE === 'firebase') {
        await addDoc(collection(db, 'votes'), {
          ...form,
          candidates,
          status: 'upcoming',
          voters: [],
          createdAt: new Date().toISOString()
        });
      } else {
        await api.post('/votes', {
          ...form,
          candidates
        });
      }
      toast.success(t('voteCreated'));
      setModal(false);
      load();
    } catch (err) {
      console.error(err);
      toast.error('Error');
    }
  };
  const changeStatus = async (id, status) => {
    try {
      if (DB_TYPE === 'firebase') {
        await updateDoc(doc(db, 'votes', id), { status });
      } else {
        await api.patch(`/votes/${id}/status`, { status });
      }
      toast.success(`${t('vote')} ${t(status + 'Label') || status}`);
      load();
    } catch (err) {
      console.error(err);
      toast.error('Error');
    }
  };
  const statusColor = s => ({
    upcoming: 'gold',
    active: 'green',
    closed: 'red'
  })[s] || 'navy';
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="fade-in">
      <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      marginBottom: 32,
      gap: 24,
      flexWrap: 'wrap'
    }}>
        <div>
          <h1 style={{
          fontFamily: 'var(--font-display)',
          fontSize: 32,
          fontWeight: 800,
          color: 'var(--sindhi-navy)',
          marginBottom: 4
        }}>{t('votingSystem')}</h1>
          <p style={{
          fontSize: 14,
          color: 'var(--sindhi-text-muted)'
        }}>{t('itemsCountMsg').replace('{count}', votes.length)} {t('votingSessions')}</p>
        </div>
        <motion.button whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="btn btn-primary" style={{
        height: 48,
        padding: '0 24px',
        borderRadius: 12,
        fontSize: 14,
        fontWeight: 800,
        background: 'var(--sindhi-maroon)',
        border: 'none',
        boxShadow: '0 8px 16px -4px rgba(0,0,0,0.15)'
      }} onClick={() => setModal(true)}>
          {t('createVote')}
        </motion.button>
      </div>

      {loading ? <div style={{
      display: 'flex',
      justifyContent: 'center',
      padding: 80
    }}>
          <div className="spinner" />
        </div> : <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 24
    }}>
          <AnimatePresence mode="popLayout">
            {votes.length === 0 ? <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} style={{
          textAlign: 'center',
          padding: 80,
          background: 'white',
          borderRadius: 24,
          border: '1px solid var(--sindhi-cream)',
          color: 'var(--sindhi-text-muted)'
        }}>
                <div style={{
            fontSize: 48,
            marginBottom: 16
          }}>🗳️</div>
                {t('noVotingSessions')}
              </motion.div> : votes.map((v, idx) => <Card key={v._id} style={{
          padding: 32,
          background: 'white',
          border: '1px solid var(--sindhi-cream)'
        }}>
                <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: 24
          }}>
                  <div>
                    <div style={{
                display: 'flex',
                gap: 10,
                marginBottom: 12
              }}>
                      <span style={{
                  padding: '4px 12px',
                  borderRadius: 8,
                  fontSize: 11,
                  fontWeight: 800,
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                  background: v.status === 'upcoming' ? '#fff5e6' : v.status === 'active' ? '#e1f9eb' : '#feecef',
                  color: v.status === 'upcoming' ? '#d97706' : v.status === 'active' ? '#1da352' : '#e11d48'
                }}>{t(v.status + 'Label') || v.status}</span>
                      {v.branch && <span style={{
                  padding: '4px 12px',
                  borderRadius: 8,
                  fontSize: 11,
                  fontWeight: 800,
                  textTransform: 'uppercase',
                  background: 'var(--sindhi-ivory)',
                  color: 'var(--sindhi-navy)'
                }}>{v.branch.name}</span>}
                    </div>
                    <h3 style={{
                fontFamily: 'var(--font-display)',
                fontSize: 20,
                fontWeight: 800,
                color: 'var(--sindhi-navy)',
                marginBottom: 8
              }}>{v.title}</h3>
                    {v.description && <p style={{
                fontSize: 14,
                color: 'var(--sindhi-text-muted)',
                lineHeight: 1.6
              }}>{v.description}</p>}
                    
                    <div style={{
                display: 'flex',
                gap: 20,
                fontSize: 12,
                color: 'var(--sindhi-text-muted)',
                fontWeight: 600,
                marginTop: 12
              }}>
                      {v.startDate && <span>📅 {t('start')}: {new Date(v.startDate).toLocaleDateString()}</span>}
                      {v.endDate && <span>📅 {t('end')}: {new Date(v.endDate).toLocaleDateString()}</span>}
                      <span>👥 {t('votesCastMsg').replace('{count}', v.voters?.length || 0)}</span>
                    </div>
                  </div>
                  
                  <div style={{
              display: 'flex',
              gap: 8
            }}>
                    {v.status === 'upcoming' && <motion.button whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="btn" style={{
                height: 40,
                padding: '0 16px',
                borderRadius: 10,
                background: '#1da352',
                color: 'white',
                border: 'none',
                fontSize: 13,
                fontWeight: 700,
                cursor: 'pointer'
              }} onClick={() => changeStatus(v._id, 'active')}>{t('activateBtn')}</motion.button>}
                    {v.status === 'active' && <motion.button whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="btn" style={{
                height: 40,
                padding: '0 16px',
                borderRadius: 10,
                background: '#e11d48',
                color: 'white',
                border: 'none',
                fontSize: 13,
                fontWeight: 700,
                cursor: 'pointer'
              }} onClick={() => changeStatus(v._id, 'closed')}>{t('closeBtn')}</motion.button>}
                    {v.status === 'closed' && <span style={{
                padding: '8px 16px',
                borderRadius: 10,
                background: '#feecef',
                color: '#e11d48',
                fontSize: 12,
                fontWeight: 800,
                textTransform: 'uppercase'
              }}>{t('closedLabel')}</span>}
                  </div>
                </div>

                {/* Candidates / Results */}
                <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
            gap: 16
          }}>
                  {v.candidates.map((c, i) => {
              const total = v.candidates.reduce((s, x) => s + x.votes, 0);
              const pct = total > 0 ? Math.round(c.votes / total * 100) : 0;
              return <div key={i} style={{
                padding: 20,
                background: 'var(--sindhi-ivory)',
                borderRadius: 16,
                border: '1px solid var(--sindhi-cream)'
              }}>
                        <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 12
                }}>
                          <div style={{
                    fontWeight: 800,
                    fontSize: 15,
                    color: 'var(--sindhi-navy)'
                  }}>{c.name}</div>
                          <div style={{
                    fontSize: 12,
                    fontWeight: 800,
                    color: 'var(--sindhi-maroon)'
                  }}>{pct}%</div>
                        </div>
                        <div style={{
                  fontSize: 12,
                  color: 'var(--sindhi-text-muted)',
                  marginBottom: 12,
                  fontWeight: 600
                }}>{c.votes} {t('votesObj')}</div>
                        <div style={{
                  height: 8,
                  background: 'white',
                  borderRadius: 4,
                  overflow: 'hidden',
                  border: '1px solid var(--sindhi-cream)'
                }}>
                          <motion.div initial={{
                    width: 0
                  }} animate={{
                    width: `${pct}%`
                  }} transition={{
                    duration: 1,
                    ease: 'easeOut'
                  }} style={{
                    height: '100%',
                    background: 'linear-gradient(90deg, var(--sindhi-maroon), var(--sindhi-navy))',
                    borderRadius: 4
                  }} />
                        </div>
                      </div>;
            })}
                </div>
              </Card>)}
          </AnimatePresence>
        </div>}

      {/* Add/Edit Modal */}
      <AnimatePresence>
        {modal && <div className="modal-overlay" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(10,25,47,0.4)',
        backdropFilter: 'blur(4px)'
      }} onClick={e => e.target === e.currentTarget && setModal(false)}>
            <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} className="modal-box" style={{
          width: 600,
          padding: 0,
          overflow: 'hidden',
          borderRadius: 24,
          background: 'white',
          boxShadow: '0 40px 100px -20px rgba(0,0,0,0.25)'
        }}>
          <div style={{
            padding: '24px 32px',
            background: 'var(--sindhi-ivory)',
            borderBottom: '1px solid var(--sindhi-cream)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <h2 style={{
              fontFamily: 'var(--font-display)',
              fontSize: 22,
              fontWeight: 800,
              color: 'var(--sindhi-navy)'
            }}>{t('createVotingSession')}</h2>
            <button style={{
              background: 'white',
              border: '1px solid var(--sindhi-cream)',
              width: 36,
              height: 36,
              borderRadius: 10,
              fontSize: 16,
              cursor: 'pointer',
              color: 'var(--sindhi-text-muted)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }} onClick={() => setModal(false)}>✕</button>
          </div>
          <form onSubmit={save} style={{
            padding: 32
          }}>
            <div className="form-group">
              <label className="form-label" style={{
                fontWeight: 700,
                color: 'var(--sindhi-navy)',
                marginBottom: 10
              }}>{t('titleLabel')} *</label>
              <input className="form-input" style={{
                height: 48,
                borderRadius: 12,
                border: '1px solid var(--sindhi-cream)'
              }} value={form.title} onChange={e => setForm(p => ({
                ...p,
                title: e.target.value
              }))} required />
            </div>
            <div className="form-group">
              <label className="form-label" style={{
                fontWeight: 700,
                color: 'var(--sindhi-navy)',
                marginBottom: 10
              }}>{t('description')}</label>
              <textarea className="form-input" style={{
                borderRadius: 16,
                border: '1px solid var(--sindhi-cream)',
                padding: 16
              }} rows={2} value={form.description} onChange={e => setForm(p => ({
                ...p,
                description: e.target.value
              }))} />
            </div>
            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: 20
            }}>
              <div className="form-group">
                <label className="form-label" style={{
                  fontWeight: 700,
                  color: 'var(--sindhi-navy)',
                  marginBottom: 10
                }}>{t('startDate')}</label>
                <input className="form-input" style={{
                  height: 48,
                  borderRadius: 12,
                  border: '1px solid var(--sindhi-cream)'
                }} type="date" value={form.startDate} onChange={e => setForm(p => ({
                  ...p,
                  startDate: e.target.value
                }))} />
              </div>
              <div className="form-group">
                <label className="form-label" style={{
                  fontWeight: 700,
                  color: 'var(--sindhi-navy)',
                  marginBottom: 10
                }}>{t('endDate')}</label>
                <input className="form-input" style={{
                  height: 48,
                  borderRadius: 12,
                  border: '1px solid var(--sindhi-cream)'
                }} type="date" value={form.endDate} onChange={e => setForm(p => ({
                  ...p,
                  endDate: e.target.value
                }))} />
              </div>
            </div>
            <div className="form-group" style={{
              background: 'var(--sindhi-ivory)',
              padding: 24,
              borderRadius: 20,
              border: '1px solid var(--sindhi-cream)'
            }}>
              <label className="form-label" style={{
                fontWeight: 800,
                color: 'var(--sindhi-navy)',
                marginBottom: 16,
                display: 'block'
              }}>{t('candidatesLabel')}</label>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 12
              }}>
                {form.candidates.map((c, i) => <div key={i} style={{
                  display: 'flex',
                  gap: 10
                }}>
                        <input className="form-input" style={{
                    height: 44,
                    borderRadius: 10,
                    border: '1px solid var(--sindhi-cream)',
                    background: 'white'
                  }} placeholder={`${t('candidate')} ${i + 1}`} value={c.name} onChange={e => setCandidate(i, e.target.value)} />
                        {form.candidates.length > 2 && <button type="button" className="btn btn-danger" style={{
                    width: 44,
                    height: 44,
                    padding: 0,
                    borderRadius: 10,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }} onClick={() => removeCandidate(i)}>✕</button>}
                      </div>)}
              </div>
              <button type="button" className="btn btn-outline" onClick={addCandidate} style={{
                marginTop: 16,
                height: 40,
                borderRadius: 10,
                fontSize: 13,
                fontWeight: 700,
                border: '1px dashed var(--sindhi-navy)',
                color: 'var(--sindhi-navy)'
              }}>{t('addCandidateLabel')}</button>
            </div>
            
            <div style={{
              marginTop: 32,
              display: 'flex',
              gap: 12,
              borderTop: '1px solid var(--sindhi-cream)',
              paddingTop: 24
            }}>
              <button type="submit" className="btn btn-primary" style={{
                height: 50,
                flex: 1,
                borderRadius: 12,
                fontSize: 14,
                fontWeight: 800,
                background: 'var(--sindhi-maroon)',
                border: 'none'
              }}>{t('createVote')}</button>
              <button type="button" onClick={() => setModal(false)} className="btn btn-outline" style={{
                height: 50,
                padding: '0 32px',
                borderRadius: 12,
                fontSize: 14,
                fontWeight: 800,
                border: '1px solid var(--sindhi-cream)',
                color: 'var(--sindhi-text-muted)'
              }}>{t('cancelLabel')}</button>
            </div>
          </form>
        </motion.div>
      </div>}
      </AnimatePresence>
    </motion.div>;
}